import { setStyles as f, getHeight as u, getMargin as p } from "../../utils/dom.js";
import { nextTick as S } from "vue";
let d, c;
function y(t, e) {
  ["position", "top", "left", "right", ...Object.keys(e.fixedStyles || {})].forEach((o) => {
    t.style.removeProperty(o);
  }), t.classList.remove("is-sticky"), t.placeholderEl.style.display = t.style.display || "inherit";
}
function m(t, e, o) {
  if (t.fixed) {
    const n = t.getBoundingClientRect(), i = o.getBoundingClientRect(), r = window.innerWidth || document.documentElement.clientWidth, s = {
      left: n.left,
      right: r - n.right,
      ...e.fixedStyles || {}
    };
    if (e.fixedStyles && e.relativeToRoot && (e.fixedStyles.left != null && (s.left = i.left - e.fixedStyles.left), e.fixedStyles.right != null)) {
      const l = r - i.right;
      s.right = l + e.fixedStyles.right;
    }
    setTimeout(() => {
      f(t, s);
    }, 0);
  } else
    setTimeout(() => {
      f(t.placeholderEl, {
        minHeight: u(t),
        height: u(t),
        ...p(t)
      });
    }, 0);
}
function E(t, e, o) {
  const { rootBounds: n, boundingClientRect: i } = t, r = window.innerWidth || document.documentElement.clientWidth, s = {
    position: "fixed",
    top: n.top,
    left: i.left,
    right: r - i.right,
    ...o.fixedStyles || {}
  };
  if (o.fixedStyles && o.relativeToRoot && (o.fixedStyles.left != null && (s.left = n.left - o.fixedStyles.left), o.fixedStyles.right != null)) {
    const l = r - n.right;
    s.right = l + o.fixedStyles.right;
  }
  e.classList.add("is-sticky"), e.placeholderEl.style.display = "block", f(e, s);
}
function x(t) {
  return document.querySelector(t.root || ".pendo-page-container");
}
function h(t, e) {
  t && t.context && t.context.$emit(e);
}
function v(t, e, o) {
  const n = x(e), i = {
    root: n || null,
    rootMargin: `${parseInt(e.rootMargin) || 0}px`,
    threshold: [0, 1]
  };
  d = new IntersectionObserver((r) => {
    r.forEach((s) => {
      const l = s.boundingClientRect, a = s.rootBounds;
      l.bottom < a.top && (t.fixed = !0, E(s, t, e), h(o, "on-affix")), l.bottom >= a.top && l.bottom < a.bottom && (t.fixed = !1, y(t, e), h(o, "off-affix"));
    });
  }, i), c = new ResizeObserver(() => {
    m(t, e, n || document.body);
  }), c.observe(n || document.body), c.observe(t), d.observe(t.sentinelEl);
}
function b(t) {
  const e = document.createElement("div");
  return f(e, {
    display: "inherit",
    position: "relative",
    minHeight: u(t),
    height: u(t),
    ...p(t)
  }), e;
}
function g() {
  const t = document.createElement("div");
  return t.classList.add("pendo-affix__sentinel"), t;
}
function R(t, e, o) {
  (typeof e.value > "u" || e.value) && S(() => {
    const n = b(t), i = g();
    t.placeholderEl = n, t.sentinelEl = i, t.parentNode && t.parentNode.insertBefore(n, t), n.appendChild(i), n.appendChild(t), v(t, e.value || {}, o);
  });
}
function C(t, e, o) {
  const n = e.value || {}, i = x(n);
  m(t, n, i || document.body), e.value.rootMargin !== e.oldValue.rootMargin && (d.unobserve(t.sentinelEl), d.disconnect(), v(t, e.value || {}, o));
}
function w(t, e) {
  d.unobserve(t.sentinelEl), d.disconnect(), c.disconnect(), y(t, e.value || {}), t.sentinelEl = void 0, t.placeholderEl = void 0, t.fixed = void 0;
}
const W = {
  mounted: R,
  updated: C,
  unmounted: w
};
export {
  W as PendoAffix,
  b as createPlaceholder,
  g as createSentinel,
  W as default,
  v as initObservers,
  y as resetFixedStyles,
  E as setFixedStyles,
  m as syncStyles
};
//# sourceMappingURL=pendo-affix.js.map
